import { render, staticRenderFns } from "./CardsAdmin.vue?vue&type=template&id=2536746f&scoped=true"
import script from "./CardsAdmin.vue?vue&type=script&lang=js"
export * from "./CardsAdmin.vue?vue&type=script&lang=js"
import style0 from "./CardsAdmin.vue?vue&type=style&index=0&id=2536746f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2536746f",
  null
  
)

export default component.exports